import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 flex items-center space-x-2 space-y-2 py-2" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-2 pt-4" }
const _hoisted_3 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiTextInput, {
      modelValue: $setup.v$.number.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.number.$model) = $event)),
      name: "number",
      type: "text",
      label: _ctx.$t('contact.form.labels.phone'),
      class: "flex-1",
      errors: $setup.v$.number.$errors,
      onBlur: $setup.v$.number.$touch
    }, null, 8 /* PROPS */, ["modelValue", "label", "errors", "onBlur"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        checked: $setup.formState.isMain,
        class: "text-primary focus:ring-primary mt-0.5",
        onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('set-main')))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
        [_directive_tippy, _ctx.$t('contact.form.actions.setMainPhone')]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
        variant: "danger",
        class: _normalizeClass(["", { 'cursor-not-allowed opacity-40': !$props.canRemove }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('remove', $props.index)))
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TrashIcon"], { class: "h-5 w-5" })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])), [
        [_directive_tippy, 
                    $props.canRemove
                        ? _ctx.$t('contact.form.actions.removePhone')
                        : _ctx.$t('contact.form.actions.cannotRemovePhone')
                ]
      ])
    ])
  ]))
}